import KanbanPage from "../../../../components/kanban";

const MaintenanceMonitoring = (props: any) => {
    return <KanbanPage persona="CONSULTANT" {...props} />;
};

export default MaintenanceMonitoring;